/**
 * Finds elements by data attribute
 * @param {string} dataKey - The data attribute key (without 'data-' prefix)
 * @param {string} dataValue - The value to match against the data attribute
 * @returns {NodeList} The matching elements
 */
export function elementsByDataSlot(dataKey, dataValue) {
  return document.querySelectorAll(`[data-${dataKey}="${dataValue}"]`)
}

/**
 * Finds calendar slots for a sequence in the current week, previous week, and next week
 * @param {string} sequenceId - The sequence ID
 * @param {string} termId - The term ID
 * @param {number} weekNumber - The week number
 * @returns {Array} The matching slot elements
 */
export function elementsForAdjacentWeeks(sequenceId, termId, weekNumber) {
  if (!sequenceId || !termId || !weekNumber) {
    return []
  }

  const weekNumbers = [weekNumber - 1, weekNumber, weekNumber + 1]
  const slots = []

  weekNumbers.forEach(week => {
    const weekSlots = document.querySelectorAll(
      `[data-calendar--sortable-target="slot"][data-sequence="${sequenceId}"][data-term="${termId}"][data-term-week="${week}"]`
    )
    slots.push(...Array.from(weekSlots))
  })

  return slots
}

/**
 * Refreshes Turbo frames within the given elements
 * @param {NodeList|Array} elements - The elements to search for turbo frames
 */
export function refreshTurboFrames(elements) {
  elements.forEach(element => {
    // Check if the element itself is a turbo-frame
    if (element.tagName === 'TURBO-FRAME') {
      element.src = element.src
    } else {
      // Find all turbo-frame elements within the element
      const turboFrames = element.querySelectorAll('turbo-frame')
      turboFrames.forEach(turboFrame => {
        turboFrame.src = turboFrame.src
      })
    }
  })
}
